import React, {useEffect, useState} from 'react';
import {useLocation, useNavigate} from 'react-router-dom';
import Environment from 'utils/Environment';
import {useExperimentQAHydration} from './QA';
import Analytics from 'utils/Analytics';

import DarkModeButton from 'components/DarkModeButton/DarkModeButton';
import {OsaQaMenu} from './OsaQaMenu';

const QABarContent = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [show, setShow] = useState(false);

  useExperimentQAHydration();

  // The OSA funnel uses the onboarding.risescience.com QA affordance: a
  // floating purple FAB pinned bottom-right that toggles a dark popup menu
  // (route jumps, modality/severity overrides, reset), instead of the gray
  // top-right pill used elsewhere. Mirrors rise-web-funnel v2's QAFab.
  const isOsaRoute = location.pathname.startsWith('/osa');

  useEffect(() => {
    if (show) {
      Analytics.track('Admin Bar Shown');
    }
  }, [show]);

  if (isOsaRoute) {
    return <OsaQaMenu />;
  }

  if (!show) {
    return (
      <div style={{...styles.container, ...{backgroundColor: 'transparent', boxShadow: 'none'}}}>
        <div onClick={() => setShow(true)} style={{...styles.button, alignSelf: 'flex-start'}}>
          QA
        </div>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      <div onClick={() => setShow(false)} style={{...styles.button, ...{backgroundColor: 'black', color: 'white'}}}>
        X
      </div>
      <div style={{display: 'flex', flexDirection: 'column', gap: '6px'}}>
        <div style={{display: 'flex', justifyContent: 'space-around', flexDirection: 'row', gap: '4px'}}>
          <div
            onClick={() => {
              navigate('/devqatools');
              setShow(false);
            }}
            style={{...styles.button, ...{backgroundColor: 'purple'}}}
          >
            Admin Screen
          </div>

          <DarkModeButton />
        </div>
      </div>
    </div>
  );
};

export const QABar = () => {
  if (Environment.isTest && !Environment.isRunningInJest()) {
    return <QABarContent />;
  }
  return null;
};

const styles: Record<string, React.CSSProperties> = {
  container: {
    position: 'absolute',
    top: 0,
    right: 0,

    padding: '4px',
    display: 'flex',
    // flexDirection: 'row',
    gap: '4px',
    fontSize: '8px',
    flexWrap: 'wrap',
    userSelect: 'none',
    zIndex: 1000,

    backgroundColor: '#eee',
    boxShadow: '0 0 10px 0 rgba(0, 0, 0, 0.8)',
    paddingBottom: '8px',
  },
  feature: {
    display: 'flex',
    backgroundColor: '#ddd',
    padding: '2px 4px',
    borderRadius: '4px',
    cursor: 'pointer',
    color: '#fff',
    alignItems: 'center',
    position: 'relative',
    height: '20px',
    gap: '4px',
  },
  enabled: {
    backgroundColor: '#0ea45e',
  },
  disabled: {
    backgroundColor: '#c34531',
  },
  button: {
    fontSize: '12px',
    backgroundColor: '#ddd',
    padding: '2px 4px',
    borderRadius: '4px',
    cursor: 'pointer',
    color: '#fff',
    minWidth: '20px',
    height: '20px',
    textAlign: 'center',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    alignSelf: 'flex-start',
  },
  override: {
    fontSize: '20px',
    color: 'yellow',
    fontWeight: '900',
    lineHeight: '12px',
  },
};
